import React, { Component } from 'react';
import { TextField, IconButton, Grid, InputAdornment, MenuItem, Select, FormControl } from '@material-ui/core'
import { AddCircle, RemoveCircle } from '@material-ui/icons'
import { Unit } from '../../api/models/TaxonomyElement';

type Props = {
    value: number,
    onChange: (value: string, unit: Unit) => void,
    readonly: boolean,
    units: Unit[],
    unit: Unit
}

type State = {
    step: number,
    allowFloat: boolean,
}

class NumberInput extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        let unit = this.props.unit || this.props.units[0]
        this.state = {
            step: 1,
            allowFloat: unit.name !== 'https://qmo.com/core#byPiece'
        }

        this.internalOnChange = this.internalOnChange.bind(this)
        this.onUnitChange = this.onUnitChange.bind(this)
    }

    internalOnChange(value: string | number, unit: Unit) {
        this.props.onChange(value.toString(), unit)
    }

    onUnitChange(e: any) {
        let selectedUnit = this.props.units.find(u => u.id === e.target.value)!
        if (selectedUnit === undefined)
            console.log("Unknown unit id")
        else
            this.internalOnChange(this.props.value, selectedUnit)
    }

    render() {
        return (
            <Grid container alignItems="center" alignContent="center" style={{ textAlign: "center" }}>
                <Grid item xs={3} sm={3}><IconButton disabled={this.props.readonly} onClick={() => this.props.value === 0 ? 0 : this.internalOnChange(this.props.value - this.state.step, this.props.unit)}><RemoveCircle /></IconButton></Grid>
                <Grid item xs={6} sm={6}>
                    <TextField
                        disabled={this.props.readonly}
                        inputProps={{ style: { textAlign: 'center' } }}
                        inputMode="numeric"
                        onChange={(e) => {
                            if (e.target.value === '')
                                this.internalOnChange(0, this.props.unit)

                            let value = this.state.allowFloat ? parseFloat(e.target.value) : parseInt(e.target.value)
                            if (value)
                                if (this.state.allowFloat && e.target.value.endsWith('.'))
                                    this.internalOnChange(value + '.', this.props.unit)
                                else
                                    this.internalOnChange(value, this.props.unit)
                        }}
                        value={this.props.value}
                        InputProps={{
                            endAdornment: <InputAdornment style={{ fontSize: '0.7em !important', textTransform: 'uppercase' }} position="end">
                                <FormControl>
                                    <Select
                                        value={this.props.unit.id}
                                        onChange={this.onUnitChange}
                                        displayEmpty
                                        style={{ fontSize: '0.7em', lineHeight: '1.1875rem' }}
                                        name="unit"
                                    >
                                        {this.props.units.map((u, i) => {
                                            return <MenuItem key={i} value={u.id}>{u.name}</MenuItem>
                                        })
                                        }
                                    </Select>
                                </FormControl>
                            </InputAdornment>
                        }}
                    />
                </Grid>
                <Grid item xs={3} sm={3}><IconButton disabled={this.props.readonly} onClick={() => this.internalOnChange(this.props.value + this.state.step, this.props.unit)}><AddCircle /></IconButton></Grid>
            </Grid>
        );
    }
}

export default NumberInput;